import React from 'react';

export default function Reports() {
  return (
    <div className='page-background p-2 p-md-4'>
      <div className="page-header">
        <div><h2>Reports</h2></div>
      </div>

    </div>
  );
}
